import React, { useState, useEffect, useRef } from "react";
import {
  Stack,
  Button,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Grid,
  InputAdornment,
  Modal,
  TextField,
  FormControl,
  Select,
} from "@mui/material";
import { Link } from "react-router-dom";
import "../App.css";
import LogoImage from "../assets/Images/Vector.png";
import MenuIcon from "../assets/Images/Menu_Icon.png";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LocationIcon from "../assets/Images/Location_Icon.png";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import _ from "lodash";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import Logout from "@mui/icons-material/Logout";
import Settings from "@mui/icons-material/Settings";
import IosShareIcon from "@mui/icons-material/IosShare";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import ChatIcon from "@mui/icons-material/Chat";
import BookOnlineOutlinedIcon from "@mui/icons-material/BookOnlineOutlined";
import WalletOutlinedIcon from "@mui/icons-material/WalletOutlined";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import axios from "axios";
import { isMobile } from "react-device-detect";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import GoogleMapReact from "google-map-react";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import DynamicFeedOutlinedIcon from "@mui/icons-material/DynamicFeedOutlined";
import { io } from "socket.io-client";
import {
  getUserById,
  getNotificationsById,
  updateNotificationsById,
  userChats,
  getMessages,
  getUserBookings,
  getServiceProviderBookings,
} from "../apis";
import { format } from "timeago.js";

const style = {
  position: "absolute",
  top: "45%",
  left: "55%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

let circle;

const Navbar = ({ changeLocation }) => {
  const socket = useRef();
  const [user, setUser] = useState({});
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [currentLocation, setCurrentLocation] = useState("");
  const [open, setOpen] = useState(false);
  const [zoom, setZoom] = useState(11);
  const [radius, setRadius] = useState(10);
  const [address, setAddress] = useState("");
  const [receivedNotifications, setReceivedNotifications] = useState([]);
  const [newNotifications, setNewNotifications] = useState(false);
  const [chats, setChats] = useState([]);
  const [profilePicture, setProfilePicture] = useState(null);
  const [activeData, setActiveData] = useState([]);
  const [selectedNotificationMethod, setSelectedNotificationMethod] =
    useState("notification");

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("user-info"));
    const userType = localStorage.getItem("user-type");
    if (items) {
      setUser(items);
      if (userType == "user") {
        setProfilePicture(items?.imageUrl);
      }
    }
    // if (userType == "service provider") {
    //   if (items.isActive == false && items.infoFilled == false) {
    //     setUser({});
    //   } else if (items.isActive == false && items.infoFilled == true) {
    //     setUser({});
    //   }
    // }
  }, [localStorage.getItem("user-info")]);

  // useEffect(() => {
  //   const userInfo = JSON.parse(localStorage.getItem("user-info"));
  //   const userType = localStorage.getItem("user-type");
  //   if (userType == "service provider") {
  //     if (userInfo.isActive == false && userInfo.infoFilled == false) {
  //       navigate("/service-provider/info");
  //     } else if (userInfo.isActive == false && userInfo.infoFilled == true) {
  //       navigate("/service-provider/under-review");
  //     } else {
  //       navigate("/feeds");
  //     }
  //   }
  // }, []);

  useEffect(() => {
    const userType = localStorage.getItem("user-type");
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const fetchUserData = async () => {
      const result = await getUserById(userInfo._id);
      setLatitude(result.data.serviceProviderInfo.personalInfo.latitude);
      setLongitude(result.data.serviceProviderInfo.personalInfo.longitude);
      setCurrentLocation(result.data.serviceProviderInfo.personalInfo.address);
      setValue(result.data.serviceProviderInfo.personalInfo.address);
      setProfilePicture(result.data.serviceProviderInfo.personalInfo.image[0]);
    };

    if (userType == "service provider") {
      fetchUserData();
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);
        axios
          .get(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&key=AIzaSyCGuRwgYRduNFkJtak6ID1PWs82gMkRaDQ`
          )
          .then((res) =>
            //console.log(res)
            {
              setCurrentLocation(res.data.results[0].formatted_address);
              setValue(res.data.results[0].formatted_address, false);
            }
          );
      });
      setProfilePicture(userInfo?.imageUrl);
    }
  }, []);

  const type = localStorage.getItem("user-type");

  const [anchorElP, setAnchorElP] = useState(null);
  const [anchorElN, setAnchorElN] = useState(null);
  const [anchorOpenMyAccount, setAnchorOpenMyAccount] = useState(null);
  const openProfile = Boolean(anchorElP);
  const openNotification = Boolean(anchorElN);
  const myAccountBoolean = Boolean(anchorOpenMyAccount);
  const handleClickP = (event) => {
    setAnchorElP(event.currentTarget);
    if (!_.isEmpty(user)) {
      const userid = user.googleId ? user.googleId : user._id;
      updateNotificationsById({ id: userid });

      setNewNotifications(false);
    }
  };
  const handleClickN = (event) => {
    setAnchorElN(event.currentTarget);
  };
  const handleOpenMyAccount = (event) => {
    setAnchorOpenMyAccount(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElP(null);
    setAnchorElN(null);
    setAnchorOpenMyAccount(null);
    setOpen(false);
  };
  const logout = () => {
    localStorage.clear();
  };

  //mobile nav menu
  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["All mail", "Trash", "Spam"].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>
              {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
            </ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const km = [
    // { value: 1, label: "1 kilometer" },
    // { value: 2, label: "2 kilometers" },
    { value: 5, label: "5 miles" },
    { value: 10, label: "10 miles" },
    { value: 20, label: "20 miles" },
    { value: 40, label: "40 miles" },
    { value: 60, label: "60 miles" },
    { value: 80, label: "80 miles" },
    { value: 100, label: "100 miles" },
    // { value: 250, label: "250 kilometers" },
    // { value: 500, label: "500 kilometers" },
  ];

  const handleRadiusChange = (e) => {
    setRadius(e.target.value);
    circle.setRadius(e.target.value * 1000);
    if (e.target.value <= 10) {
      setZoom(11);
    }
    if (e.target.value > 10 && e.target.value <= 20) {
      setZoom(10);
    }
    if (e.target.value > 20 && e.target.value <= 40) {
      setZoom(9);
    }
    if (e.target.value > 40 && e.target.value <= 60) {
      setZoom(8);
    }
    if (e.target.value > 60 && e.target.value <= 100) {
      setZoom(7);
    }
  };

  const handleSelect =
    ({ description }) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      setValue(description, false);
      setAddress(description);
      clearSuggestions();
      circle.setRadius(radius * 1000);

      // Get latitude and longitude via utility functions
      getGeocode({ address: description }).then((results) => {
        const { lat, lng } = getLatLng(results[0]);
        // console.log("📍 Coordinates: ", { lat, lng });
        setLatitude(lat);
        setLongitude(lng);
        circle.setCenter({ lat: lat, lng: lng });
      });
    };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        // <li key={place_id} onClick={handleSelect(suggestion)}>
        //   <strong>{main_text}</strong> <small>{secondary_text}</small>
        // </li>
        <div
          style={{
            padding: "10px",
            borderBottom: "1px solid #EEEBEF",
            cursor: "pointer",
          }}
          onClick={handleSelect(suggestion)}
        >
          <Typography>
            {main_text}, {secondary_text}
          </Typography>
        </div>
      );
    });

  const apiIsUpdated = (map, maps) => {
    circle = new maps.Circle({
      strokeColor: "#FF0000",
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: "#FF0000",
      fillOpacity: 0.3,
      map,
      center: { lat: latitude, lng: longitude },
      radius: radius * 1000,
    });
  };

  useEffect(() => {
    const fetchNotifications = async (id) => {
      const response = await getNotificationsById(id);
      const { data } = await userChats(id);
      let chatsArray = [];
      await Promise.all(
        data.map(async (item) => {
          const userId = item.members.find((_id) => _id !== id);
          const dataID = item._id;
          const res = await getMessages(dataID);
          const { data } = await getUserById(userId);

          const filteredData = res.data.filter((x) => x.senderId != id);
          filteredData.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          if (filteredData.length) {
            chatsArray.push({
              conv: item,
              user: data.user,
              time: filteredData[0].createdAt,
            });
          } else {
            chatsArray.push({ conv: item, user: data.user, time: "" });
          }
        })
      );
      setChats(chatsArray);
      let arr = response.data.notifications;
      arr.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      setReceivedNotifications(arr);
      if (response.data.notifications.some((e) => e.read === false)) {
        setNewNotifications(true);
      }
    };

    const fetchBookings = async (id) => {
      if (type == "user") {
        const response = await getUserBookings(id);
        setActiveData(response.data.activeRequests);
      }
      if (type == "service provider") {
        const response = await getServiceProviderBookings(id);
        setActiveData(response.data.activeRequests);
      }
    };

    if (!_.isEmpty(user)) {
      const userid = user.googleId ? user.googleId : user._id;
      fetchNotifications(userid);
      fetchBookings(userid);
      socket.current = io("https://ammanat-chat-socket.herokuapp.com");
      socket.current.emit("new-user-add", userid);
      socket.current.on("recieve-notification", (data) => {
        setNewNotifications(true);
        let arr = [...receivedNotifications, data];
        arr.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setReceivedNotifications(arr);
      });
    }
  }, [user]);

  if (isMobile) {
    return (
      <>
        <div
          style={{ width: "100%", backgroundColor: "white" }}
          className="pt-6 pb-6"
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ width: "90%", margin: "auto" }}
          >
            <Stack
              direction="row"
              alignItems="center"
              style={{
                backgroundColor: "rgba(10, 100, 188, 0.05)",
                padding: "8px",
                paddingRight: "12px !important",
                borderRadius: "40px",
              }}
            >
              <LocationOnOutlinedIcon
                style={{ color: "rgba(10, 100, 188, 1)", fontSize: "20px" }}
              />
              <span
                style={{ color: "#0A64BC", fontSize: "12px" }}
                className="location-ellipsis"
              >
                {currentLocation}
              </span>
            </Stack>
            <div>
              <Link to="/">
                <Stack direction="row" spacing={1} alignItems="center">
                  <img
                    src={LogoImage}
                    alt="logo"
                    style={{ height: "33px", width: "50px" }}
                  />
                  <span
                    className="default-color"
                    style={{
                      fontWeight: "700",
                      fontSize: "20px",
                    }}
                  >
                    Ammannat
                  </span>
                </Stack>
              </Link>
            </div>
          </Stack>
        </div>
      </>
    );
  } else {
    return (
      <>
        <Modal
          open={open}
          // onClose={handleCloseConfirmation}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Stack justifyContent="center" alignItems="center">
              <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
                Change Location
              </Typography>
            </Stack>
            <Stack className="mt-10">
              <Typography className="ammanat-darker-gray">Location</Typography>
              <TextField
                required
                size="small"
                variant="outlined"
                className="w-100"
                placeholder="Enter your address"
                value={value}
                disabled={!ready}
                onChange={(e) => {
                  setAddress(e.target.value);
                  setValue(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FmdGoodOutlinedIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
            <Stack>
              {/* We can use the "status" to decide whether we should display the dropdown or not */}
              {status === "OK" && (
                <div
                  style={{
                    border: "1px solid #EEEBEF",
                    borderRadius: "6px",
                    background: "white",
                    position: "absolute",
                    zIndex: "100",
                    width: "89%",
                  }}
                  className="mb-16"
                >
                  {renderSuggestions()}
                </div>
              )}
            </Stack>
            <Stack className="mt-10">
              <Typography className="ammanat-darker-gray">Radius</Typography>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={radius}
                  onChange={(e) => handleRadiusChange(e)}
                  // displayEmpty
                  // placeholder="Select Category"
                >
                  {km.map((item) => (
                    <MenuItem value={item.value}>{item.label}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
            <Stack className="mt-10" style={{ height: "350px" }}>
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: "AIzaSyCGuRwgYRduNFkJtak6ID1PWs82gMkRaDQ",
                }}
                center={{
                  lat: latitude,
                  lng: longitude,
                }}
                defaultZoom={11}
                zoom={zoom}
                draggable={false}
                options={{
                  disableDefaultUI: true,
                }}
                yesIWantToUseGoogleMapApiInternals={true}
                onGoogleApiLoaded={({ map, maps }) => apiIsUpdated(map, maps)}
              >
                <FmdGoodIcon
                  lat={latitude}
                  lng={longitude}
                  className="default-color"
                />
              </GoogleMapReact>
            </Stack>
            <Stack
              className="mt-10"
              direction="row"
              spacing={3}
              justifyContent="flex-end"
            >
              <Button
                variant="outlined"
                className="default-border default-color"
                style={{ textTransform: "capitalize" }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="primary-button"
                style={{ textTransform: "capitalize" }}
                onClick={() => {
                  setCurrentLocation(value);
                  handleClose();
                  changeLocation(latitude, longitude, radius);
                }}
              >
                Apply
              </Button>
            </Stack>
          </Box>
        </Modal>

        <div>
          <Drawer
            anchor="left"
            open={state["left"]}
            onClose={toggleDrawer("left", false)}
          >
            {list("left")}
          </Drawer>
        </div>
        <div
          style={{ width: "100%", backgroundColor: "white" }}
          className="pt-6 pb-6"
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            style={{ width: "90%", margin: "auto" }}
          >
            <div style={{ width: "45%" }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Stack direction="row" spacing={1} alignItems="center">
                  <img
                    src={MenuIcon}
                    alt="MenuIcon"
                    // onClick={toggleDrawer("left", true)}
                  />
                  <span style={{ color: "#222222" }}>Categories</span>
                </Stack>
                <Stack
                  direction="row"
                  alignItems="center"
                  style={{
                    backgroundColor: "rgba(10, 100, 188, 0.05)",
                    padding: "8px",
                    paddingRight: "12px !important",
                    borderRadius: "40px",
                    cursor: "pointer",
                  }}
                  onClick={() => setOpen(true)}
                >
                  <LocationOnOutlinedIcon
                    style={{ color: "rgba(10, 100, 188, 1)", fontSize: "20px" }}
                  />
                  <span
                    style={{ color: "#0A64BC", fontSize: "12px" }}
                    className="location-ellipsis"
                  >
                    {currentLocation}
                  </span>
                </Stack>
              </Stack>
            </div>
            <Stack
              style={{ width: "52%" }}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <div>
                <Link to="/">
                  <Stack direction="row" spacing={1} alignItems="center">
                    <img
                      src={LogoImage}
                      alt="logo"
                      style={{ height: "33px", width: "50px" }}
                    />
                    <span
                      className="default-color"
                      style={{
                        fontWeight: "700",
                        fontSize: "20px",
                      }}
                    >
                      Ammannat
                    </span>
                  </Stack>
                </Link>
              </div>
              <div>
                {_.isEmpty(user) ? (
                  <Stack direction="row" spacing={4} alignItems="center">
                    {/* <Link to="/admin">
                    <span>Admin</span>
                  </Link> */}
                    {/* <Link to="/choose-flow" state={{ flow: "register" }}>
                    <span>Become Partner</span>
                  </Link> */}
                    <Link to="/choose-flow" state={{ flow: "register" }}>
                      <span style={{ color: "#222222" }}>Sign Up</span>
                    </Link>
                    <Link to="/login">
                      <span style={{ color: "#222222" }}>Login</span>
                    </Link>
                    <Link to="/create-request">
                      <Button
                        variant="contained"
                        className="primary-button"
                        size="small"
                        style={{
                          padding: "8px 16px",
                          textTransform: "capitalize",
                          fontSize: "16px",
                          fontWeight: "500",
                          borderRadius: "6px",
                        }}
                      >
                        Post Request
                      </Button>
                    </Link>
                  </Stack>
                ) : (
                  <Stack direction="row" spacing={4} alignItems="center">
                    {/* <ContactSupportOutlinedIcon /> */}
                    {type == "user" || type == "service provider" ? (
                      <Typography
                        style={{ cursor: "pointer" }}
                        onClick={handleOpenMyAccount}
                      >
                        {" "}
                        My Account
                      </Typography>
                    ) : null}

                    <IconButton
                      onClick={handleClickP}
                      size="small"
                      sx={{ ml: 2 }}
                      aria-controls={openProfile ? "account-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={openProfile ? "true" : undefined}
                    >
                      <NotificationsNoneIcon />
                      {newNotifications ? (
                        <div
                          style={{
                            backgroundColor: "red",
                            borderRadius: "50%",
                            position: "absolute",
                            left: "17px",
                            top: "5px",
                            width: "10px",
                            height: "10px",
                          }}
                        ></div>
                      ) : (
                        <></>
                      )}
                    </IconButton>

                    <IconButton
                      onClick={handleClickN}
                      size="small"
                      sx={{ ml: 2 }}
                      aria-controls={
                        openNotification ? "account-menu" : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={openNotification ? "true" : undefined}
                    >
                      <Avatar
                        alt={
                          user.googleId
                            ? user.name.toUpperCase()
                            : user.fullName.toUpperCase()
                        }
                        src={
                          profilePicture != null
                            ? profilePicture
                            : "/static/images/avatar/3.jpg"
                        }
                      />
                    </IconButton>

                    {type == "user" ? (
                      <Menu
                        anchorEl={anchorElN}
                        id="account-menu"
                        open={openNotification}
                        onClose={handleClose}
                        onClick={handleClose}
                        PaperProps={{
                          elevation: 0,
                          sx: {
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: 1.5,
                            "& .MuiAvatar-root": {
                              width: 32,
                              height: 32,
                              ml: -0.5,
                              mr: 1,
                            },
                            "&:before": {
                              content: '""',
                              display: "block",
                              position: "absolute",
                              top: 0,
                              right: 14,
                              width: 10,
                              height: 10,
                              bgcolor: "background.paper",
                              transform: "translateY(-50%) rotate(45deg)",
                              zIndex: 0,
                            },
                          },
                        }}
                        transformOrigin={{
                          horizontal: "right",
                          vertical: "top",
                        }}
                        anchorOrigin={{
                          horizontal: "right",
                          vertical: "bottom",
                        }}
                      >
                        {" "}
                        <Link to="/create-request">
                          <MenuItem>
                            <ListItemIcon>
                              <IosShareIcon fontSize="small" />
                            </ListItemIcon>{" "}
                            Post a request
                          </MenuItem>
                        </Link>
                        <Link to="/recieved-bids">
                          <MenuItem>
                            <ListItemIcon>
                              <CallReceivedIcon fontSize="small" />
                            </ListItemIcon>{" "}
                            Received Bids
                          </MenuItem>
                        </Link>
                        <Link to="/my-requests">
                          <MenuItem>
                            <ListItemIcon>
                              <RequestPageIcon fontSize="small" />
                            </ListItemIcon>
                            My Requests
                          </MenuItem>
                        </Link>
                        <Link to="/chat">
                          <MenuItem>
                            <ListItemIcon>
                              <ChatIcon fontSize="small" />
                            </ListItemIcon>
                            Messages
                          </MenuItem>
                        </Link>
                        <Link to="/login">
                          <MenuItem onClick={logout}>
                            <ListItemIcon>
                              <Logout fontSize="small" />
                            </ListItemIcon>
                            Logout
                          </MenuItem>
                        </Link>
                      </Menu>
                    ) : type == "service provider" ? (
                      <Menu
                        anchorEl={anchorElN}
                        id="account-menu"
                        open={openNotification}
                        onClose={handleClose}
                        onClick={handleClose}
                        PaperProps={{
                          elevation: 0,
                          sx: {
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: 1.5,
                            "& .MuiAvatar-root": {
                              width: 32,
                              height: 32,
                              ml: -0.5,
                              mr: 1,
                            },
                            "&:before": {
                              content: '""',
                              display: "block",
                              position: "absolute",
                              top: 0,
                              right: 14,
                              width: 10,
                              height: 10,
                              bgcolor: "background.paper",
                              transform: "translateY(-50%) rotate(45deg)",
                              zIndex: 0,
                            },
                          },
                        }}
                        transformOrigin={{
                          horizontal: "right",
                          vertical: "top",
                        }}
                        anchorOrigin={{
                          horizontal: "right",
                          vertical: "bottom",
                        }}
                      >
                        {" "}
                        {user.isActive == true && user.infoFilled == true ? (
                          <>
                            <Link to="/feeds">
                              <MenuItem>
                                <ListItemIcon>
                                  <DynamicFeedOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                Feeds
                              </MenuItem>
                            </Link>
                            <Link to="/favourites">
                              <MenuItem>
                                <ListItemIcon>
                                  <DynamicFeedOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                My Favourites
                              </MenuItem>
                            </Link>
                            <Link to="/chat">
                              <MenuItem>
                                <ListItemIcon>
                                  <ChatIcon fontSize="small" />
                                </ListItemIcon>
                                Messages
                              </MenuItem>
                            </Link>

                            <Link to="/my-earnings">
                              <MenuItem>
                                <ListItemIcon>
                                  <WalletOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                My Earnings
                              </MenuItem>
                            </Link>
                            <Link to="/personalisedFeed">
                              <MenuItem>
                                <ListItemIcon>
                                  <DynamicFeedOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                Personal Requests
                              </MenuItem>
                            </Link>

                            <Link to="/login">
                              <MenuItem onClick={logout}>
                                <ListItemIcon>
                                  <Logout fontSize="small" />
                                </ListItemIcon>
                                Logout
                              </MenuItem>
                            </Link>
                          </>
                        ) : (
                          <Link to="/login">
                            <MenuItem onClick={logout}>
                              <ListItemIcon>
                                <Logout fontSize="small" />
                              </ListItemIcon>
                              Logout
                            </MenuItem>
                          </Link>
                        )}
                      </Menu>
                    ) : type == "admin" ? (
                      <Menu
                        anchorEl={anchorElN}
                        id="account-menu"
                        open={openNotification}
                        onClose={handleClose}
                        onClick={handleClose}
                        PaperProps={{
                          elevation: 0,
                          sx: {
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: 1.5,
                            "& .MuiAvatar-root": {
                              width: 32,
                              height: 32,
                              ml: -0.5,
                              mr: 1,
                            },
                            "&:before": {
                              content: '""',
                              display: "block",
                              position: "absolute",
                              top: 0,
                              right: 14,
                              width: 10,
                              height: 10,
                              bgcolor: "background.paper",
                              transform: "translateY(-50%) rotate(45deg)",
                              zIndex: 0,
                            },
                          },
                        }}
                        transformOrigin={{
                          horizontal: "right",
                          vertical: "top",
                        }}
                        anchorOrigin={{
                          horizontal: "right",
                          vertical: "bottom",
                        }}
                      >
                        {" "}
                        <Link to="/admin/dashboard">
                          <MenuItem>
                            <ListItemIcon>
                              <RequestPageIcon fontSize="small" />
                            </ListItemIcon>
                            Dashboard
                          </MenuItem>
                        </Link>
                        <Link to="/login">
                          <MenuItem onClick={logout}>
                            <ListItemIcon>
                              <Logout fontSize="small" />
                            </ListItemIcon>
                            Logout
                          </MenuItem>
                        </Link>
                      </Menu>
                    ) : (
                      <></>
                    )}

                    <Menu
                      anchorEl={anchorElP}
                      id="account-menu"
                      open={openProfile}
                      onClose={handleClose}
                      // onClick={handleClose}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflowY: "scroll",
                          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                          mt: 1.5,
                          minWidth: "500px",
                          maxHeight: "600px",
                          "& .MuiAvatar-root": {
                            width: 52,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                          },
                          "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                          },
                        },
                      }}
                      transformOrigin={{ horizontal: "right", vertical: "top" }}
                      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    >
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="center"
                        style={{
                          backgroundColor: "#F5F5F5",
                          borderRadius: "8px",
                          padding: "10px",
                          width: "90%",
                          margin: "auto",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          style={{
                            width: "50%",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          className={
                            selectedNotificationMethod == "notification"
                              ? "selected-payment-method"
                              : ""
                          }
                          onClick={() =>
                            setSelectedNotificationMethod("notification")
                          }
                        >
                          <Typography>Notifications</Typography>
                        </div>
                        <div
                          style={{
                            width: "50%",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                          className={
                            selectedNotificationMethod == "messages"
                              ? "selected-payment-method"
                              : ""
                          }
                          onClick={() =>
                            setSelectedNotificationMethod("messages")
                          }
                        >
                          <Typography>Messages</Typography>
                        </div>
                      </Stack>
                      {selectedNotificationMethod == "notification" ? (
                        receivedNotifications.length ? (
                          receivedNotifications.map((notification) => (
                            <>
                              <MenuItem>
                                <Grid className="d-flex">
                                  <Grid item>
                                    <ListItemIcon>
                                      <NotificationsNoneIcon fontSize="small" />
                                    </ListItemIcon>
                                  </Grid>

                                  <Grid item>
                                    <Link
                                      to={
                                        notification.message ==
                                        "New bid received. You have a new bid"
                                          ? "/recieved-bids"
                                          : "/my-bookings"
                                      }
                                    >
                                      <Typography
                                        variant="subtitle2"
                                        gutterBottom
                                        component="div"
                                      >
                                        {notification.message}
                                      </Typography>
                                      <Typography
                                        variant="subtitle2"
                                        gutterBottom
                                        component="div"
                                        className="ammanat-darker-gray"
                                      >
                                        {format(notification.createdAt)}
                                      </Typography>
                                    </Link>
                                  </Grid>
                                </Grid>
                              </MenuItem>
                            </>
                          ))
                        ) : (
                          <MenuItem>
                            <Grid className="d-flex">
                              <Grid item>
                                <div>
                                  <Typography
                                    variant="subtitle2"
                                    gutterBottom
                                    component="div"
                                  >
                                    No new notification to show
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </MenuItem>
                        )
                      ) : chats.length ? (
                        chats.map((chat) => (
                          <>
                            {chat.time != "" ? (
                              <MenuItem>
                                <Grid className="d-flex">
                                  <Grid item>
                                    <ListItemIcon>
                                      <NotificationsNoneIcon fontSize="small" />
                                    </ListItemIcon>
                                  </Grid>

                                  <Grid item>
                                    <Link to="/chat">
                                      <Typography
                                        variant="subtitle2"
                                        gutterBottom
                                        component="div"
                                      >
                                        You have received a new message from{" "}
                                        {chat.user.fullName}
                                      </Typography>
                                      <Typography
                                        variant="subtitle2"
                                        gutterBottom
                                        component="div"
                                        className="ammanat-darker-gray"
                                      >
                                        {format(chat.time)}
                                      </Typography>
                                    </Link>
                                  </Grid>
                                </Grid>
                              </MenuItem>
                            ) : (
                              <></>
                            )}
                          </>
                        ))
                      ) : (
                        <></>
                      )}
                    </Menu>

                    <Menu
                      anchorEl={anchorOpenMyAccount}
                      id="account-menu"
                      open={myAccountBoolean}
                      onClose={handleClose}
                      onClick={handleClose}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: "visible",
                          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                          mt: 1.5,
                          "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                          },
                          "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                          },
                        },
                      }}
                      transformOrigin={{
                        horizontal: "right",
                        vertical: "top",
                      }}
                      anchorOrigin={{
                        horizontal: "right",
                        vertical: "bottom",
                      }}
                    >
                      {" "}
                      {type == "service provider" ? (
                        <Link to={`/expert-profile/${user._id}`}>
                          <MenuItem>
                            <ListItemIcon>
                              <AccountCircleOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            My Profile
                          </MenuItem>
                        </Link>
                      ) : (
                        <></>
                      )}
                      <Link to="/my-bookings">
                        <MenuItem>
                          <ListItemIcon>
                            <ShoppingBagOutlinedIcon fontSize="small" />
                          </ListItemIcon>
                          <Stack
                            direction="row"
                            spacing={3}
                            alignItems="center"
                          >
                            {activeData.length ? (
                              <>
                                <Typography>My Bookings</Typography>
                                <Typography
                                  style={{
                                    background: "#FF6D1C",
                                    color: "white",
                                    fontWeight: "600",
                                    fontSize: "12px",
                                    lineHeight: "15px",
                                    borderRadius: "15px",
                                    padding: "5px",
                                  }}
                                >
                                  {activeData.length} in Progress
                                </Typography>
                              </>
                            ) : (
                              <Typography>My Bookings</Typography>
                            )}
                          </Stack>
                        </MenuItem>
                      </Link>
                      <Link to="/FAQ">
                        <MenuItem>
                          <ListItemIcon>
                            <HelpOutlineOutlinedIcon fontSize="small" />
                          </ListItemIcon>
                          FAQs
                        </MenuItem>
                      </Link>
                      <Link to="/terms-and-conditions">
                        <MenuItem>
                          <ListItemIcon>
                            <TextSnippetOutlinedIcon fontSize="small" />
                          </ListItemIcon>
                          Terms and Conditions
                        </MenuItem>
                      </Link>
                      <Link to="/privacyPolicy">
                        <MenuItem>
                          <ListItemIcon>
                            <LockOutlinedIcon fontSize="small" />
                          </ListItemIcon>
                          Privacy Policy
                        </MenuItem>
                      </Link>
                    </Menu>
                  </Stack>
                )}
              </div>
            </Stack>
          </Stack>
        </div>
        <div className="footer-line"></div>
      </>
    );
  }
};
export default React.memo(Navbar);
